import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import { IPage, IUtility } from 'common/src/types/interfaces';
import {
  ICreateUtilityDto,
  IUpdateUtilityDto,
} from 'common/src/types/utility.dtos';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getUtilities = async (
  params?: DataQueryParams,
): Promise<IPage<IUtility>> =>
  await getRequest(API_BASE_PATHS.UTILITIES, formatQueryParams(params));

export const getUtility = async (id: string): Promise<IUtility> =>
  await getRequest(`${API_BASE_PATHS.UTILITIES}/${id}`);

export const addUtility = async (body: ICreateUtilityDto): Promise<string> =>
  await postRequest(API_BASE_PATHS.UTILITIES, {}, body);

export const updateUtility = async (
  id: string,
  body: IUpdateUtilityDto,
): Promise<void> =>
  await patchRequest(`${API_BASE_PATHS.UTILITIES}/${id}`, {}, body);

export const deleteUtility = async (id: string): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.UTILITIES}/${id}`, {});
